import { Link as MuiLink, Stack } from '@mui/material';
import { Link } from '@tanstack/react-router';

import { useAuthTranslation } from '../i18n/auth-i18n';
import { AUTH_PATHS } from '../lib/auth-paths';
import { AuthLayout } from './AuthLayout';
import { EmailPasswordForm } from './EmailPasswordForm';

export interface ForgotPasswordPageProps {
  logo: React.ReactElement;
  brandingSubtitle: string;
}

const LINK_SX = {
  color: 'text.secondary',
  textDecorationColor: 'transparent',
  transition: 'color 160ms ease, text-decoration-color 160ms ease',
  '@media (hover: hover)': { '&:hover': { color: 'text.primary', textDecorationColor: 'currentColor' } },
} as const;

export function ForgotPasswordPage({ logo, brandingSubtitle }: ForgotPasswordPageProps) {
  const { t } = useAuthTranslation();
  return (
    <AuthLayout logo={logo} brandingSubtitle={brandingSubtitle} data-testid="auth.forgot-password-page">
      <EmailPasswordForm mode="forgotPassword" />
      <Stack spacing={1} alignItems="center" sx={{ mt: 3 }}>
        <MuiLink component={Link} to={AUTH_PATHS.login} variant="body2" underline="hover" sx={LINK_SX}>
          {t('auth.common.backToSignIn')}
        </MuiLink>
      </Stack>
    </AuthLayout>
  );
}
